<template>
    <dialogComponent name="ieAlert">
        <template v-slot="dialog">
            <div class="fp_modal">
                    <div class="cell">
                        <div class="modal_cont" style="width:450px;">
                            <div class="cont">
                                <div class="modal_cont_tips" style="text-align:center;">
                                    <div class="img">
                                        <img :src="dialog.logoUrl">
                                    </div>
                                    <h3 v-html="dialog.options.title"></h3>
                                    <span name="warning_dialog_message">
                                        <p style="padding:25px">为提供最佳的游戏体验，请使用平台建议的浏览器<br>Edge、Firefox、搜狗、Google Chrome！</p>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        </template>
    </dialogComponent>
</template>

<script>
export default {
    name: "IEAlert",
    methods: {
        showDialog() {
            let _ieAlertDialog = this.$dialog.get('ieAlert');
            _ieAlertDialog.show();
        },
    },
}
</script>